import { RefObject, useEffect, useRef } from 'react';
import { tracker } from 'src/utils/analytics';
import { useIntersectionObserver } from 'src/hooks/use-intersection-observer';
import { WalletPassSurface } from 'src/utils/analytics/events';

type UseLoyaltyPassImpressionTrackingProps = {
  type: 'button' | 'qrCode';
  surface?: WalletPassSurface;
};

type UseLoyaltyPassImpressionTrackingReturn = {
  ref: RefObject<HTMLDivElement>;
};
export const useLoyaltyPassImpressionTracking = ({
  type,
  surface,
}: UseLoyaltyPassImpressionTrackingProps): UseLoyaltyPassImpressionTrackingReturn => {
  const ref = useRef<HTMLDivElement>(null);

  const entry = useIntersectionObserver(ref, {
    threshold: 0.1,
    freezeOnceVisible: true,
  });

  useEffect(() => {
    if (entry?.isIntersecting) {
      // Spread rather than always setting the key, so callers that don't pass a surface get a
      // byte-identical payload to before `surface` existed (no `surface: undefined` in the object).
      tracker.walletPass({ action: 'viewed', type, ...(surface ? { surface } : {}) });
    }
  }, [entry?.isIntersecting, type, surface]);

  return { ref };
};
